import { render, staticRenderFns } from "./BibliaPage.vue?vue&type=template&id=d34849d0"
import script from "./BibliaPage.vue?vue&type=script&lang=js"
export * from "./BibliaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports